(() => {
  if (customElements.get('sx-review-hub')) return;
  let loading;
  const widgets = () => {
    if (window.twttr?.widgets) return Promise.resolve(window.twttr);
    if (loading) return loading;
    loading = new Promise((resolve,reject) => {
      const start = Date.now();
      const timer = setInterval(() => {
        if (window.twttr?.widgets) {clearInterval(timer);resolve(window.twttr);}
        else if (Date.now()-start>12000) {clearInterval(timer);reject(new Error('Unavailable'));}
      },100);
      if (!document.querySelector('script[src="https://platform.twitter.com/widgets.js"]')) {
        const script=document.createElement('script');script.src='https://platform.twitter.com/widgets.js';script.async=true;document.head.append(script);
      }
    }).catch(e=>{loading=undefined;throw e;});
    return loading;
  };
  customElements.define('sx-review-hub',class extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.select=this.querySelector('select');
      this.more=this.querySelector('.sx-hub__more');
      this.select.addEventListener('change',()=>this.show());
      this.more.addEventListener('click',()=>this.querySelector('.sx-hub__panel:not([hidden]) .sx-review-trigger')?.click());
      const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.visible=true;this.show();observer.disconnect();}},{rootMargin:'200px'});
      observer.observe(this);this.observer=observer;this.show();
    }
    disconnectedCallback(){this.observer?.disconnect();}
    show(){
      this.querySelectorAll('[data-item]').forEach(panel=>panel.hidden=panel.dataset.item!==this.select.value);
      const panel=this.querySelector('.sx-hub__panel:not([hidden])');
      this.more.disabled=!panel?.querySelector('.sx-review-trigger');
      if(!panel||!this.visible||panel.dataset.loaded)return;
      panel.dataset.loaded='true';
      const grid=panel.querySelector('.sx-hub__previews');let posts=[];
      try{posts=JSON.parse(panel.querySelector('sx-review-rating')?.dataset.posts||'[]')}catch{}
      posts.slice(0,3).forEach(post=>{
        let url;try{url=new URL(post.url)}catch{return}
        const match=url.pathname.match(/^\/(?:[\w]+|i\/web)\/status\/(\d+)/);
        if(url.protocol!=='https:'||!['x.com','www.x.com','twitter.com','www.twitter.com'].includes(url.hostname)||!match)return;
        const card=document.createElement('article');card.className='sx-hub__post';
        const embed=document.createElement('div');embed.className='sx-hub__embed';
        const fallback=document.createElement('p');fallback.textContent=grid.dataset.fallback;
        const link=document.createElement('a');link.href=url.href;link.target='_blank';link.rel='noopener noreferrer';link.textContent=grid.dataset.open;
        card.append(embed,fallback,link);grid.append(card);
        widgets().then(t=>t.widgets.createTweet(match[1],embed,{theme:'light',dnt:true,conversation:'none',lang:document.documentElement.lang.startsWith('ja')?'ja':'en'})).then(el=>{if(el)fallback.hidden=true}).catch(()=>{});
      });
    }
  });
})();
